import { render, staticRenderFns } from "./DrawerResourcesSection.vue?vue&type=template&id=79357fca&"
import script from "./DrawerResourcesSection.vue?vue&type=script&lang=js&"
export * from "./DrawerResourcesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports